import { render, staticRenderFns } from "./pkgTypek.vue?vue&type=template&id=c4038b12&"
import script from "./pkgTypek.vue?vue&type=script&lang=js&"
export * from "./pkgTypek.vue?vue&type=script&lang=js&"
import style0 from "./pkgTypek.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports